import React from "react";
import CarImage from "./CarImage.png";
import { useTheme } from "@mui/material";
import Button from "components/basic/button";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Home: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <>
      <section id="home" style={{ display: "flex" }}>
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            height: "calc(-210px + 100vh)",
            justifyContent: "center",
          }}
        >
          <img
            alt={t("nav.home_graphic_alt")}
            src={CarImage}
            style={{
              width: "70%",
            }}
          />
        </div>
      </section>

      <div
        style={{
          position: "fixed",
          bottom: "25px",
          left: 0,
          width: "100%",
          display: "flex",
          gap: theme.spacing(2),
          justifyContent: "center",
        }}
      >
        <Button
          style={{ fontWeight: "bold", fontSize: "1.1em" }}
          variant="text"
          onClick={() => navigate("/about")}
        >
          {t("nav.about")}
        </Button>

        <Button
          style={{ fontWeight: "bold", fontSize: "1.1em" }}
          variant="text"
          onClick={() => navigate("/signin")}
        >
          {t("nav.login")}
        </Button>

        <Button
          style={{ fontWeight: "bold", fontSize: "1.1em" }}
          variant="text"
          onClick={() => navigate("/contact")}
        >
          {t("nav.contact")}
        </Button>
      </div>
    </>
  );
};

export default Home;
